import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  StyledBoxDown,
  StyledButton,
  StyledButtonPlus,
  StyledLabelError
} from './style';
import LanguageItem from './LanguageItem';
import Modal from '../../../core/Modal';
import { LANGUAGE } from '../../../../constants/literals/modals';
import { moveElementPosition } from '../../../../utils/splices';

class Language extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.dataLanguage,
      btnIsDisabled: true,
      controlError: false
    };
  }

  componentDidMount() {
    const { data } = this.state;

    if (data.length === 0) {
      this.handlePlus();
    }
  }

  onClickDelete = index => {
    const { data } = this.state;
    const updatedData = data.filter((ele, i) => i !== index);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  onClickOrderArrow = (index, isDown) => {
    const { data } = this.state;
    const move = isDown ? index + 1 : index - 1;
    const updatedData = moveElementPosition([...data], index, move);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  getBtnStatus = data => {
    const { dataLanguage } = this.props;

    return _.isEqual(dataLanguage, data);
  };

  handleAccept = () => {
    const { onAcceptModal } = this.props;
    const { data } = this.state;
    let error = false;
    const updatedData = data.reduce((acc, ele) => {
      if (ele.certification.length > 0 && ele.name.length > 0) {
        acc.push({
          name: ele.name,
          certification: ele.certification,
          proficiency: ele.proficiency,
          accreditation: ele.accreditation,
          languageId: ele.languageId
        });
      } else {
        this.setState({ controlError: true });
        error = true;
      }
      return acc;
    }, []);
    if (!error) {
      onAcceptModal(updatedData);
    }
  };

  handleChange = (value, index, key) => {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData[index] = { ...clonedData[index], [key]: value };

    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  handleChangeRadio = (index, key, event) => {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData[index] = { ...clonedData[index], [key]: event.target.value };
    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  handlePlus = () => {
    const { selectedNivel } = this.props;
    const { data } = this.state;
    const clonedData = [...data];

    clonedData.push({
      name: '',
      certification: '',
      proficiency: selectedNivel,
      languageId: 0
    });

    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  render() {
    const { onCloseModal, listNivel, formUser } = this.props;
    const { data, btnIsDisabled, controlError } = this.state;
    return (
      <Modal title={LANGUAGE.TITLE} clickCloseIcon={onCloseModal} tabletSize>
        {data.map((item, index) => (
          <LanguageItem
            key={`Language${index + 1}`}
            certification={item.certification}
            accreditation={
              item.accreditation ? item.accreditation.toString() : ''
            }
            listNivel={listNivel}
            name={item.name}
            formUser={formUser}
            onChangeInputName={e => {
              this.handleChange(e, index, 'name');
            }}
            onChangeIdLanguage={e => {
              this.handleChange(e, index, 'languageId');
            }}
            onChangeInputProficiency={e =>
              this.handleChange(e, index, 'certification')
            }
            onChangeRadioLevel={e =>
              this.handleChangeRadio(index, 'proficiency', e)
            }
            onChangeRadioCertification={e =>
              this.handleChangeRadio(index, 'accreditation', e)
            }
            onClickDelete={() => this.onClickDelete(index)}
            onClickDown={() => this.onClickOrderArrow(index, true)}
            onClickUp={() => this.onClickOrderArrow(index, false)}
            order={index + 1}
            proficiency={item.proficiency}
          />
        ))}
        <StyledButtonPlus onClick={this.handlePlus} dark tabletSize />
        {controlError && (
          <StyledLabelError>*Faltan campos por rellenar</StyledLabelError>
        )}
        <StyledBoxDown>
          <StyledButton onClick={onCloseModal} modal>
            {LANGUAGE.CANCEL}
          </StyledButton>
          <StyledButton
            onClick={this.handleAccept}
            secondary
            disabled={btnIsDisabled}
          >
            {LANGUAGE.ACCEPT}
          </StyledButton>
        </StyledBoxDown>
      </Modal>
    );
  }
}

Language.propTypes = {
  dataLanguage: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      certification: PropTypes.string,
      proficiency: PropTypes.string,
      id: PropTypes.string
    })
  ),
  formUser: PropTypes.bool,
  listNivel: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      text: PropTypes.string
    })
  ),
  onAcceptModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  selectedNivel: PropTypes.string
};

Language.defaultProps = {
  dataLanguage: [],
  selectedNivel: 'MEDIO',
  listNivel: [
    { value: 'INICIAL', text: 'Inicial (A1, A2)' },
    { value: 'MEDIO', text: 'Medio (B1, B2)' },
    { value: 'SUPERIOR', text: 'Superior (C1, C2)' }
  ],
  formUser: false
};

export default Language;
